module.exports = __webpack_public_path__ + "img/OVCA_NK.09ac70d2.png";